const events = [
    {
        name: "Valorant",
        description: "So This is it! 👏👏The Countdown has begun. We are few moments away from the much awaited finals of the tournament that gave us goosebumps during its campaign. Valorant Final is here. So Get Ready for the Biggest Clash of the Tournament as most Dominating Teams are going to collide today.Don't forget to join our special Event on 13th November 2022 (Sunday) At 11:00 AM Venue: S5  (Lecture Hall) So let's Bring It On.🔥",
        venue: "Room-S5  (Lecture Hall)",
        mode: "Online",
        date: "13th November 2022 (Sunday)",
        timing: "11:00 AM",
        category: "Team",
        playersperteam: "5",
        prize: "Rs.3500",
        poster: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_21-min.png?ik-sdk-version=javascript-1.4.3&updatedAt=1674421567496",
        background: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_2__1_-compressed.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1674422102290",
        video:"https://www.youtube.com/embed/e_E9W2vsRbQ"

    },
    {
        name: "Fifa",
        description: "The favorite part about any game is the opportunity to play”Hola Gamers! Get Ready to Scream - Goallll on top of your lungs as you put the ball behind the net after dribbling past the entire team. Finally, this is your opportunity to present your skills and show the real gamer inside of you.Resurgence eSports brings you “Interbranch eFIFA tournament” where you can show your amazing skills and lead your team to victory. Call upon your team and get ready for this exciting tournament. ",
        venue: "Room-S5  (Lecture Hall)",
        mode: "Offline",
        date: "Oct 19, 2022",
        timing: "5:00pm",
        category: "Team",
        playersperteam: "3",
        prize: "To be announced soon",
        poster: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_23-min.png?ik-sdk-version=javascript-1.4.3&updatedAt=1674421567374",
        background: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_2__1_-compressed.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1674422102290",
        video:"https://www.youtube.com/embed/e_E9W2vsRbQ"


    },
    {
        name: "Free to play",
        description: "We have been conducting regular gaming sessions for everyone associated with the fest. Every time someone is on break from their work, they visit our gaming area to have a little fun and chill out. Having received very good reviews, we shall continue with this. Students shall come with their friends and have fun playing various games. Friendly duels and competitive matches will be played throughout the main fest days with many games to choose from.Games that we provide-Tekken7,fifa,Smackdown,valorant,tekken3,gtaV",
        venue: "Room-S5  (Lecture Hall)",
        mode: "Offline",
        date: "Everyday",
        timing: "5pm - 8pm",
        category: "Solo",
        playersperteam: "1",
        prize: "None",
        poster: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_25-min.png?ik-sdk-version=javascript-1.4.3&updatedAt=1674421567431",
        background: "https://ik.imagekit.io/jpnn4qofy/Resurgence_2k23/Rectangle_2__1_-compressed.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1674422102290",
        video:"https://www.youtube.com/embed/e_E9W2vsRbQ"


    },
];

export default events;